import React, {Component} from 'react'
import PropTypes from 'prop-types'
import StudentsList from "../../../../../../../../components/_ead/StudentsList"
import ReleaseRequests from "../../../../../../../../requests/release-requests"
import {getClassTypeNameByCode} from "../../../../../../../../helpers/product"


const SIMULATE_GET_CONTENTS_ERROR = false

class ListOfStudents extends Component {

    state = {
        awaiting: true,
        list: [],
        selectedRadio: 'alphabetic'

    }


    componentDidMount() {
        const {release} = this.props

        const req = SIMULATE_GET_CONTENTS_ERROR ?
            Promise.reject('SIMULATE_GET_CONTENTS_ERROR') :
            ReleaseRequests
                .getCoursePersonList({
                    prlCode: release.code
                })
        req
            .then(result => {
                this.setState({
                    list: result
                })
            })
            .catch(error => {

                this.props.context.set({
                    toastMessage: {
                        type: 'error',
                        content: 'Ocorreu um erro inesperado.'
                    }
                })
                this.props.context.logError(JSON.stringify(error))
            })
    }


    render() {

        return (
            <div style={{width: '100%'}}>
                <StudentsList
                    contents={this.state.list}
                    onlineCourse={getClassTypeNameByCode(this.props.release.productDTO.classType) === 'Online'}
                />
                {
                    this.state.list.length === 0 &&
                    <div>
                        <h3 style={{
                            textAlign: 'center',
                            opacity: .5,
                            margin: 10
                        }}>
                            Não existem alunos matriculados neste curso no momento.
                        </h3>
                    </div>
                }
            </div>
        )
    }
}


ListOfStudents.propTypes = {
    context: PropTypes.object.isRequired,
}
ListOfStudents.defaultProps = {}

export default ListOfStudents



// WEBPACK FOOTER //
// ./src/_pages/Account/_pages/CourseList/_pages/Course/_partials/ListOfStudents/index.js